import React, {Fragment} from "react";
import {Box} from "@mui/material";
import moment from "moment";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {appConfigDateFormatSelector} from "../../state/app-config/appConfigSelectors";

const DatasetInfo = ({datasetSource, datasetLastUpdate, datasetNotes}) => {
  const {t} = useTranslation();

  const dateFormat = useSelector(appConfigDateFormatSelector);

  return (
    <Fragment>
      {datasetSource && (
        <Box
          id="data-viewer__header__info-dialog__source"
          sx={{
            fontStyle: "italic",
            color: "rgba(0, 0, 0, 0.54)",
            marginBottom: "12px"
          }}
        >
          <span>{t("scenes.dataViewer.header.infoDialog.source") + ": "}</span>
          <span>{datasetSource}</span>
        </Box>
      )}
      {datasetLastUpdate && (
        <Box
          id="data-viewer__header__info-dialog__lastUpdate"
          sx={{
            fontStyle: "italic",
            color: "rgba(0, 0, 0, 0.54)",
            marginBottom: "12px"
          }}
        >
          <span>{t("scenes.dataViewer.header.infoDialog.lastUpdate") + ": "}</span>
          <span>{moment(datasetLastUpdate).format(dateFormat)}</span>
        </Box>
      )}
      {datasetNotes && (
        <Box
          id="data-viewer__header__info-dialog__notes"
          sx={{
            display: "flex",
            flexDirection: "column"
          }}
        >
          <span>{t("scenes.dataViewer.header.infoDialog.notes") + ": "}</span>
          <span>{datasetNotes}</span>
        </Box>
      )}
    </Fragment>
  );
};

export default DatasetInfo;
